import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
// import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { useConfig } from './models/Config'
import { getUserMeOptions, getStateOptions } from '@/client/@tanstack/react-query.gen';
import MainLayout from '@/layouts/MainLayout';
import Loading from '@/components/Loading';
import { useStore } from './store';

const Home = React.lazy(() => import('@/pages/Home'));

const App = () => {
	const { userLoaded: _userLoaded, updateState } = useStore()
	const { data: config, status: statusSettings, error: _errSettings } = useConfig();
	const { data: userData, status, error: _error } = useQuery(getUserMeOptions());
	const { data: _dataState, status: statusState } = useQuery({
		...getStateOptions(),
		enabled: !!userData?.uid
	})

	useEffect(() => {
		if (status == 'success' || status == 'error') {
			updateState('userLoaded', true)
		}
	}, [status])

	useEffect(() => {
		if (statusState == 'success' || statusState == 'error') {
			updateState('loaded', true)
		}
	}, [statusState])

	useEffect(() => {
		if (statusSettings == 'success' || statusSettings == 'error') {
			let delta = 0;

			updateState('loaded', true)
			updateState('delta', delta)
			updateState('errors', config?.errors)
			updateState('params', config as any)
		}
	}, [statusSettings])

	return (
		<BrowserRouter basename="/">
			<Suspense fallback={<Loading />}>
				<MainLayout>
					<Routes>
						<Route path="/" element={<Home />}></Route>
						<Route
							path="*"
							element={
								<>
									<div className="text-center">Oops! Not found!</div>
								</>
							}
						></Route>
					</Routes>
				</MainLayout>
			</Suspense>
		</BrowserRouter>
	);
};

export default App;
